import { useEffect, useState } from "react";
import { backend, producturl } from "../../../../path";
import useRazorpay from "react-razorpay";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Button, Collapse, Modal } from "react-bootstrap";
import ScrollToTop from "../../../components/whatsapp connect";
import LoaderMain from "../../../layout/header/loader_sub";
import { Rating } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { MdOutlineLocalOffer } from "react-icons/md";
import { HiOutlinePlus } from "react-icons/hi2";
import { LuMinus } from "react-icons/lu";

const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;

function Cart(props) {
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const [couponSuccess, setCouponSuccess] = useState("");
  const [Razorpay] = useRazorpay();
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    country: "102",
  });
  const [address, setAddress] = useState([]);
  const [delAd, setDelAd] = useState(null);
  const [newAdd, setNewAdd] = useState({
    country: "102",
  });
  const [count, setCountry] = useState([]);
  const [open, setOpen] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const [newDelivery, setNewDelivery] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [coupon, setCoupon] = useState(0);
  const [couponId, setCouponId] = useState("");
  const navigate = useNavigate();
  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
    // window.location.reload();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  const fetchData = () => {
    setLoading(true);

    fetch(backend + `getcartbyuseriduserside`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchCountryData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcountry", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCountry(data);
        console.log(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchAddress = () => {
    setLoading(true);

    fetch(backend + "getaddress", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // keep addresses
        setAddress(data);
        // default select the most recently added (last) address
        if (Array.isArray(data) && data.length > 0) {
          const last = data[data.length - 1];
          setFormData(last);
          setDelAd(last?.delivery_address_id);
        } else {
          setFormData({ country: "102" });
          setDelAd(null);
        }
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const calculateTotal = () => {
    let total = 0;
    data.forEach((item) => {
      total += item?.total;
    });
    return total;
  };
  const calculateTotalMRP = () => {
    let total = 0;
    data.forEach((item) => {
      total += item?.total;
    });
    return total;
  };
  const calculateTotalSHIPPING = () => {
    let total = 0;
    data.forEach((item) => {
      total += item?.shipping_charge;
    });
    return total;
  };

  const calculateTotalMRPCoupon = () => {
    let total = 0;
    data.forEach((item) => {
      total += item?.total;
    });
    console.log(total - couponSuccess?.amount);
    if (couponSuccess?.amount < 50) {
      const discount = total * (couponSuccess.amount / 100);
      return total - discount; // Final discounted price
    } else {
      return total - couponSuccess?.amount;
    }
  };

  useEffect(() => {
    fetchData();
    fetchCountryData();
    fetchAddress();
  }, []);
  console.log(couponSuccess);

  // const handleQuantityChange = async (id, qty) => {
  //   console.log("Handling quantity change for ID:", id);
  //   console.log("New quantity:", qty);

  // };

  const handleDecrement = async (id, qty) => {
    if (qty === 1) {
      return;
    }
    const formData = {
      quantity: qty - 1,
      cart_id: id,
    };

    try {
      const response = await fetch(backend + "updatecartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        fetchData();
      } else if (response.status === 409) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleIncrement = async (id, qty) => {
    const formData = {
      quantity: qty + 1,
      cart_id: id,
    };

    try {
      const response = await fetch(backend + "updatecartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        fetchData();
      } else if (response.status === 409) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDeleteCart = async (id) => {
    try {
      const response = await fetch(backend + `deletecartbyiduserside/${id}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(),
      });

      if (response.status === 200) {
        fetchData();
        props.setCartChange(!props.cartChange);
      } else if (response.status === 409) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //payment

  const handlePayment = async (id, total, details, razorpayOrderId) => {
    if (!RAZORPAY_KEY) {
      toast.error("Payment gateway unavailable. Please contact support.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (!razorpayOrderId) {
      toast.error("Unable to initiate payment. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const options = {
      key: RAZORPAY_KEY,
      amount: total * 100,
      currency: "INR",
      name: "Kerala Special",
      description: "Order Payment",
      image: "https://keralaspecial.in/storage/general/ks-logo32.png",
      order_id: razorpayOrderId,
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        handleSuccessOrder(id, response.razorpay_payment_id);
      },
      prefill: {
        name: `${details?.first_name} ${details?.last_name}`,
        email: details?.email,
        contact: details?.contact,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new Razorpay(options);

    rzp1.on("payment.failed", function (response) {
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
    });

    rzp1.on("payment.success", function (response) { });
    rzp1.open();
  };

  const handleSubmit = () => {
    console.log(formData);
    // List of required fields and their corresponding display names
    if (!formData) {
      toast.error(`Please enter the fields`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      const requiredFields = [
        { key: "first_name", displayName: "First Name" },
        {
          key: "house_name",
          displayName: "House Name / House Number / Apartment",
        },
        { key: "country", displayName: "Country" },
        { key: "state", displayName: "State" },
        { key: "city", displayName: "City" },
        { key: "pincode", displayName: "Pincode" },
        { key: "contact", displayName: "Contact" },
      ];
      // Check if any required field is missing or blank
      const invalidField = requiredFields.find((field) => {
        const value = formData[field.key];
        return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
      });

      if (invalidField) {
        toast.error(`${invalidField.displayName} cannot be blank`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return; // Stop further execution
      }

      fetch(backend + "addaddress", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            console.error(
              "Failed to register:",
              response.status,
              response.statusText
            );
            if (response.status === 409) {
              toast.error("Something Went Wrong", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else {
            }

            return;
          }

          response.json().then((data) => {
            handleOrderAddress(data);
            fetchAddress();
            setOpen(false);
            // Additional success handling code here
            toast.success("Primary Address Updated", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          });
          // navigate("/admin-users");
        })
        .catch((error) => { });
    }
  };
  const handleSubmitNewAddress = () => {
    // List of required fields and their corresponding display names
    const requiredFields = [
      { key: "first_name", displayName: "First Name" },
      {
        key: "house_name",
        displayName: "House Name / House Number / Apartment",
      },
      { key: "country", displayName: "Country" },
      { key: "state", displayName: "State" },
      { key: "city", displayName: "City" },
      { key: "pincode", displayName: "Pincode" },
      { key: "contact", displayName: "Contact" },
    ];

    // Check if any required field is missing or blank
    const invalidField = requiredFields.find((field) => {
      const value = newAdd[field.key];
      return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
    });

    if (invalidField) {
      toast.error(`${invalidField.displayName} cannot be blank`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    newAdd.is_primary = 1;
    fetch(backend + "addaddress", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(newAdd),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
          }

          return;
        }

        response.json().then((data) => {
          handleOrderAddress(data);
          fetchAddress();
          setOpen(false);
          setNewDelivery(false);
          // Additional success handling code here
          toast.success("Address Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => { });
  };

  const handleOrder = () => {
    if (delAd === null) {
      toast.error("Please choose a delivery address", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    let payload = {};
    payload.delivery_id = delAd;
    payload.cart_id = data.map((item) => item.cart_id);
    payload.coupon_id = couponSuccess?.coupon_id;
    // payload.category_id = data.map((item) => item.category_id);

    fetch(backend + "createorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
          }

          return;
        }

        response.json().then((data) => {
          handlePayment(
            data.order_no,
            data.grandTotalPrice,
            data.user_details,
            data.razorpay_order_id
          );
          // Additional success handling code here
          // toast.success("Order Generated", {
          //   position: "top-right",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
        });
        // navigate("/admin-users");
      })
      .catch((error) => { });
  };
  const handleOrderAddress = (item) => {
    let payload = {};
    payload.delivery_id = item.delivery_address_id;
    payload.cart_id = data.map((item) => item.cart_id);

    fetch(backend + "createorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
          }

          return;
        }

        response.json().then((data) => {
          handlePayment(
            data.order_no,
            data.grandTotalPrice,
            data.user_details,
            data.razorpay_order_id
          );
          // Additional success handling code here
          // toast.success("Order Generated", {
          //   position: "top-right",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
        });
        // navigate("/admin-users");
      })
      .catch((error) => { });
  };

  const handleSuccessOrder = (order_id, pay_id) => {
    setLoading(true);

    let payload = {};
    payload.razorpay_payment_id = pay_id;
    payload.order_no = order_id;
    payload.cart_id = data.map((item) => item.cart_id);

    fetch(backend + "successfullpayment", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Payment verification failed", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response
          .json()
          .then((data) => {
            setLoading(false);
            toast.success("Order Placed Successfully", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            navigate("/success");
          })
          .catch((err) => {
            setLoading(false);
            console.error("JSON Error:", err);
          });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Fetch Error:", error);
      });
  };
  const handleCoupon = () => {
    let payload = {};
    payload.amount = calculateTotal();
    payload.code = couponId;
    payload.category_id = data.map((item) => item.category_id);

    fetch(backend + "checkcoupon", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 405) {
            toast.error("Coupon not applicable for selected Products", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          if (response.status === 401) {
            setCouponId("");
            toast.error("Invalid Coupon", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (response.status === 402) {
            toast.error("Not Applicable For this Amount", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (response.status === 403) {
            toast.error("Coupon Already Used", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          return;
        }
        response.json().then((data) => {
          setCouponId("");
          setCoupon(2);
          setCouponSuccess(data);
          toast.success("Coupon Applied", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => { });
  };

  const handleDeleteAddress = async (id) => {
    try {
      const response = await fetch(backend + `deleteaddress/${id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(),
      });

      if (response.status === 200) {
        fetchAddress();
        toast.success("Address Deleted", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 409) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  console.log("coupon : ", coupon);
  console.log("coupon status : ", couponSuccess);
  console.log(formData);
  console.log("data : ", data && data);

  return (
    <>
      <main className="main " id="main-section">
        <div className="page-header breadcrumb-wrap">
          <div className="container-fluid">
            <div className="breadcrumb">
              <div className="breadcrumb-item d-inline-block">
                <a href="/" title="Home">
                  {" "}
                  Home{" "}
                </a>
              </div>
              <span></span>
              <div className="breadcrumb-item d-inline-block active">
                <div itemprop="item"> Your Cart </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper">
          <Header>
            <H2>Your Cart</H2>
          </Header>
          <div>
            <div className="mb-50">
              <div className="">
                <div className="d-flex justify-content-end">
                  {authenticated && data.length > 0 && (
                    <div>
                      {coupon === 1 ? (
                        <div className="d-flex gap-3">
                          <input
                            type="text"
                            value={couponId ?? ""}
                            onChange={(event) =>
                              setCouponId(event.target.value)
                            }
                            className=""
                          />
                          <button
                            type="button"
                            className="btn hover-up btn-light"
                            style={{ backgroundColor: "#FFA62F" }}
                            onClick={handleCoupon}
                          >
                            Apply
                          </button>
                        </div>
                      ) : coupon === 0 ? (
                        <CouponBtn type="button" onClick={() => setCoupon(1)}>
                          <MdOutlineLocalOffer />
                          Apply Coupon
                        </CouponBtn>
                      ) : (
                        <button
                          type="button"
                          className="btn hover-up btn-light"
                          style={{ backgroundColor: "#ACD793" }}
                          disabled
                        >
                          Coupon Applied
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="">
                <CartFlex>
                  <LeftCol>
                    <AddressBar>
                      <div className="address-left">
                        <span className="label">Deliver to:</span>
                        <span className="value">
                          {(() => {
                            const sel = address?.find((a) => a?.delivery_address_id === delAd) || (address && address[address.length - 1]);
                            return sel
                              ? `${sel?.first_name ?? ''} ${sel?.last_name ?? ''}, ${sel?.house_name ?? ''}, ${sel?.city ?? ''} ${sel?.pincode ?? ''}`.trim()
                              : `Add an address`;
                          })()}
                        </span>
                      </div>
                      <ChangeButton type="button" onClick={() => setIsAddressModalOpen(true)}>Change</ChangeButton>
                    </AddressBar>
                    <div className="product-grid mx-1">
                      {loading && (
                        <div>
                          <LoaderMain />
                        </div>
                      )}
                      <CardBoxContainer>
                        {!loading &&
                          (data.length > 0 ? (
                            <>
                              <CartBoxTop>
                                <p>Item Name</p>
                                <p>Price</p>
                                <p>Quantity</p>
                                <p>Total Amount</p>
                                <p>Remove</p>
                              </CartBoxTop>
                              {data.map((item, i) => (
                                <CartBox
                                  className=" wow animate__animated animate__fadeIn"
                                  data-wow-delay="0.1s"
                                >
                                  <Section className="one">
                                    <div>
                                      <a
                                        onClick={() =>
                                          handleProductRoute(item.product_slug)
                                        }
                                      >
                                        <ImageContainer>
                                          <img
                                            // src={mediaurl + item.images}
                                            src={producturl + item?.thumbnail}
                                          // alt="Nestle Original Coffee-Mate Coffee Creamer"
                                          />
                                          {/* <img
                                      className="hover-img"
                                      style={{
                                        height: "200px",
                                        width: "100%",
                                        objectFit: "contain",
                                        objectPosition: "center",
                                      }}
                                      src={producturl + item?.thumbnail2}
                                      // alt="Nestle Original Coffee-Mate Coffee Creamer"
                                    /> */}
                                        </ImageContainer>
                                      </a>
                                    </div>
                                    <div>
                                      <Link
                                        className="smallLink"
                                        onClick={() =>
                                          handleProductRoute(item.product_slug)
                                        }
                                      >
                                        {item?.category_name}
                                      </Link>
                                      <Link
                                        href={`/product/${item.product_slug}`}
                                        onClick={() =>
                                          handleProductRoute(item.product_slug)
                                        } // title="Nestle Original Coffee-Mate Coffee Creamer"
                                      >
                                        {item?.product_name}
                                      </Link>
                                      <div className="product-rate-cover">
                                        <div className="d-inline-block">
                                          <Rating
                                            name="read-only"
                                            value={item?.average_stars}
                                            readOnly
                                            size="small"
                                          />
                                        </div>
                                        <span
                                          className="font-small ml-5 text-muted"
                                          style={{ verticalAlign: "top" }}
                                        >
                                          ({item?.average_stars ?? "Not Yet Rated"})
                                        </span>
                                      </div>
                                      <span className="font-small text-muted">
                                        Sold By{" "}
                                        <b style={{ fontWeight: "700" }}>
                                          <a
                                          // onClick={() => handleProductRoute(item.product_slug)}
                                          >
                                            {item?.manufacturer_name ??
                                              "KeralaSpecial"}
                                          </a>
                                        </b>
                                      </span>
                                    </div>
                                  </Section>
                                  <Section className="two">
                                    {" "}
                                    <div className="product-content-wrap">
                                      <span>₹ {item?.mrp} </span>
                                    </div>
                                    <QtyBtn className="mobile">
                                      <Btn
                                        onClick={() =>
                                          handleDecrement(
                                            item?.cart_id,
                                            item?.quantity
                                          )
                                        }
                                      >
                                        <LuMinus />
                                      </Btn>
                                      <div>
                                        <input
                                          type="text"
                                          min="1"
                                          value={item?.quantity}

                                        // onChange={(event) =>
                                        //   handleQuantityChange(
                                        //     item.cart_id,
                                        //     event.target.value
                                        //   )
                                        // }
                                        />
                                      </div>

                                      <Btn
                                        onClick={() =>
                                          handleIncrement(
                                            item?.cart_id,
                                            item?.quantity
                                          )
                                        }
                                      >
                                        <HiOutlinePlus />
                                      </Btn>
                                    </QtyBtn>
                                  </Section>
                                  <Section className="three">
                                    <QtyBtn>
                                      <Btn
                                        onClick={() =>
                                          handleDecrement(
                                            item?.cart_id,
                                            item?.quantity
                                          )
                                        }
                                      >
                                        <LuMinus />
                                      </Btn>
                                      <div>
                                        <input
                                          type="text"
                                          min="1"
                                          value={item?.quantity}

                                        // onChange={(event) =>
                                        //   handleQuantityChange(
                                        //     item.cart_id,
                                        //     event.target.value
                                        //   )
                                        // }
                                        />
                                      </div>

                                      <Btn
                                        onClick={() =>
                                          handleIncrement(
                                            item?.cart_id,
                                            item?.quantity
                                          )
                                        }
                                      >
                                        <HiOutlinePlus />
                                      </Btn>
                                    </QtyBtn>
                                  </Section>
                                  <Section className="four">
                                    <div>
                                      <h3>₹ {item?.total}</h3>
                                    </div>
                                  </Section>
                                  <Section>
                                    {/* <div className="pt-5 mt-5">
                                      <Icon
                                        icon="openmoji:delete"
                                        color="black"
                                        className="hover-up"
                                        fontSize={46}
                                        onClick={() => handleDeleteCart(item?.cart_id)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </div> */}
                                    <DeleteButton
                                      type="button"
                                      onClick={(e) => { e.stopPropagation(); handleDeleteCart(item?.cart_id); }}
                                    >
                                      Delete
                                    </DeleteButton>
                                  </Section>

                                </CartBox>
                              ))}
                            </>
                          ) : (
                            <div className="empty-cart text-center " style={{ padding: "24px 0" }}>
                              <img
                                src="/storage/general/cart.png"
                                alt="Empty cart"
                                className="mx-auto"
                                style={{ width: 200, maxWidth: "60%", height: "auto", marginBottom: 12 }}
                              />
                              <h3 className="mt-2" style={{ color: "#111827", fontWeight: 700 }}>Your cart is empty</h3>
                              <p style={{ color: "#6b7280", margin: "6px 0 14px" }}>Explore products and add items to your cart.</p>
                              <button
                                type="button"
                                className="btn hover-up"
                                style={{ background: "#fa9801", color: "#fff", border: "none", borderRadius: "10px", padding: "10px 16px", fontWeight: 600 }}
                                onClick={() => navigate('/')}
                              >
                                Explore Products
                              </button>
                            </div>
                          ))}
                      </CardBoxContainer>
                    </div>
                  </LeftCol>
                  <RightCol>
                    <SummaryCard>
                      <SummaryTitle>Price Details</SummaryTitle>
                      <SummaryRow>
                        <span>Price ({data.length} {data.length === 1 ? 'Item' : 'Items'})</span>
                        <span>₹ {calculateTotalMRP().toFixed(2)}</span>
                      </SummaryRow>
                      <SummaryRow>
                        <span>Discount</span>
                        <DiscountValue>
                          {couponSuccess ? (
                            couponSuccess.amount < 50
                              ? `- ₹ ${(calculateTotalMRP() * (couponSuccess.amount / 100)).toFixed(2)}`
                              : `- ₹ ${Number(couponSuccess.amount).toFixed(2)}`
                          ) : `₹ 0.00`}
                        </DiscountValue>
                      </SummaryRow>
                      <SummaryRow>
                        <span>Shipping Fee</span>
                        <span>₹ {calculateTotalSHIPPING().toFixed(2)}</span>
                      </SummaryRow>
                      <Divider />
                      <SummaryRow className="total">
                        <strong>Total Amount</strong>
                        <strong>
                          ₹ {(
                            (couponSuccess
                              ? (couponSuccess.amount < 50
                                ? (calculateTotalMRP() - (calculateTotalMRP() * (couponSuccess.amount / 100)))
                                : (calculateTotalMRP() - couponSuccess.amount))
                              : calculateTotalMRP())
                            + calculateTotalSHIPPING()
                          ).toFixed(2)}
                        </strong>
                      </SummaryRow>
                      <OrderButton onClick={handleOrder} disabled={data.length === 0}>Order</OrderButton>
                    </SummaryCard>
                  </RightCol>
                </CartFlex>

                <Modal show={isAddressModalOpen} onHide={() => setIsAddressModalOpen(false)} size="lg" centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Delivery Address</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="mb-3 d-flex gap-2">
                      {address[0]?.city ? (
                        <Button
                          onClick={() => { setNewDelivery(!newDelivery); setOpen(false); }}
                          aria-controls="example-new-text"
                          aria-expanded={newDelivery}
                        >
                          Add New
                        </Button>
                      ) : (
                        <Button
                          onClick={() => { setNewDelivery(false); setOpen(!open); }}
                          aria-controls="example-collapse-text"
                          aria-expanded={open}
                        >
                          Edit Primary Address
                        </Button>
                      )}
                    </div>

                    <AddressGrid>
                      {address?.map((item, i) => {
                        const selected = delAd === item?.delivery_address_id;
                        return (
                          <AddressCard
                            key={i}
                            className={selected ? "selected" : ""}
                            onClick={() => setDelAd(item?.delivery_address_id)}
                          >
                            <div className="card-main">
                              <AddressName>{item?.first_name} {item?.last_name}</AddressName>
                              {item?.house_name && item?.countryname && item?.city && item?.pincode ? (
                                <AddressMeta>
                                  {item?.house_name}, {item?.street_name}, {item?.city}, {item?.state}, {item?.countryname} - {item?.pincode}
                                  <br />PH NO: {item?.contact}
                                </AddressMeta>
                              ) : (
                                <AddressMeta>No more details</AddressMeta>
                              )}
                            </div>
                            <DeleteButton
                              type="button"
                              onClick={(e) => { e.stopPropagation(); handleDeleteAddress(item?.delivery_address_id); }}
                            >
                              Delete
                            </DeleteButton>
                          </AddressCard>
                        );
                      })}
                    </AddressGrid>

                    {delAd && (
                      <SelectedPreview>
                        {(() => {
                          const sel = address?.find((a) => a?.delivery_address_id === delAd);
                          return sel ? (
                            <div>
                              <strong>Selected:</strong> {sel?.first_name} {sel?.last_name} — {sel?.house_name}, {sel?.street_name}, {sel?.city}, {sel?.state}, {sel?.countryname} - {sel?.pincode}. PH: {sel?.contact}
                            </div>
                          ) : null;
                        })()}
                      </SelectedPreview>
                    )}

                    {open && (
                      <div className="pt-2" id="example-collapse-text">
                        <ModalForm>
                          <div className="form__content">
                            <div className="row">
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="name">First Name</label>{" "}
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" name="product_name" id="txt-name" type="text" value={formData?.first_name || ""}
                                    onChange={(e) => setFormData({ ...formData, first_name: e.target.value })} placeholder="First Name" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="name">Last Name</label>{" "}
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" name="last_name" id="txt-name" type="text" value={formData?.last_name || ""}
                                    onChange={(e) => setFormData({ ...formData, last_name: e.target.value })} placeholder="Last Name" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-12">
                                <div className="">
                                  <label htmlFor="name">House Name / House Number / Apartment</label>{" "}
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" name="house_name" id="txt-name" type="text" value={formData?.house_name || ""}
                                    onChange={(e) => setFormData({ ...formData, house_name: e.target.value })} placeholder="House Name / House Number / Apartment" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="name">Street Name</label>{" "}
                                  <input className="" name="street_name" id="txt-name" type="text" value={formData?.street_name || ""}
                                    onChange={(e) => setFormData({ ...formData, street_name: e.target.value })} placeholder="Street Name" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="city">City</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="city" required value={formData?.city || ""}
                                    onChange={(e) => setFormData({ ...formData, city: e.target.value })} placeholder="City" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="state">State</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="state" required value={formData?.state || ""}
                                    onChange={(e) => setFormData({ ...formData, state: e.target.value })} placeholder="State" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="country">Country</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <select name="category_name" id="txt-name" required value={formData?.country || ""}
                                    onChange={(e) => setFormData({ ...formData, country: e.target.value })}>
                                    <option>- select -</option>
                                    {count.map((val) => (
                                      <option value={val.country_id}>{val.countryname}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="pincode">Pin Code</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="pincode" required value={formData?.pincode || ""} maxLength={6}
                                    onChange={(e) => setFormData({ ...formData, pincode: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Pincode" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="street_name">Contact Number</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="phone" minLength={6} maxLength={12} required value={formData?.contact || ""}
                                    onChange={(e) => setFormData({ ...formData, contact: e.target.value.replace(/[^0-9+]/g, "") })} placeholder="Primary contact number" />
                                </div>
                              </div>
                            </div>
                            <div className="mt-2">
                              <Button className="btn btn-secondary" onClick={() => handleSubmit()}>Submit</Button>
                            </div>
                          </div>
                        </ModalForm>
                      </div>
                    )}

                    {newDelivery && (
                      <div className="pt-2" id="example-new-text">
                        <ModalForm>
                          <div className="form__content">
                            <div className="row">
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="name">First Name</label>{" "}
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" name="product_name" id="txt-name" type="text"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} value={newAdd?.first_name || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, first_name: e.target.value })} placeholder="First Name" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="name">Last Name</label>{" "}
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" name="last_name" id="txt-name" type="text"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} value={newAdd?.last_name || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, last_name: e.target.value })} placeholder="Last Name" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-12">
                                <div className="">
                                  <label htmlFor="name">House Name / House Number / Apartment</label>{" "}
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" name="house_name" id="txt-name" type="text"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} value={newAdd.house_name || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, house_name: e.target.value })} placeholder="House Name / House Number / Apartment" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="name">Street Name</label>{" "}
                                  <input className="" name="street_name" id="txt-name" type="text"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} value={newAdd.street_name || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, street_name: e.target.value })} placeholder="Street Name" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="city">City</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="city"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} required value={newAdd.city || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, city: e.target.value })} placeholder="City" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="state">State</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="state"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} required value={newAdd.state || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, state: e.target.value })} placeholder="State" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="country">Country</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <select className="" name="category_name" id="txt-name"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} required value={newAdd.country || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, country: e.target.value })}>
                                    <option>- select -</option>
                                    {count.map((val) => (
                                      <option value={val.country_id}>{val.countryname}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="pincode">Pin Code</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="pincode"
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} required value={newAdd.pincode || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, pincode: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Pincode" />
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-4 col-6">
                                <div className="">
                                  <label htmlFor="street_name">Contact Number</label>
                                  <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                                  <input className="" type="text" name="phone" minLength={6} maxLength={12}
                                    style={{ backgroundColor: "#fff", color: "#000", border: "1px solid #000" }} required value={newAdd.contact || ""}
                                    onChange={(e) => setNewAdd({ ...newAdd, contact: e.target.value.replace(/[^0-9+]/g, "") })} placeholder="Primary contact number" />
                                </div>
                              </div>
                            </div>
                            <div className="mt-2">
                              <Button className="btn btn-secondary" onClick={() => handleSubmitNewAddress()}>Submit</Button>
                            </div>
                          </div>
                        </ModalForm>
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIsAddressModalOpen(false)}>Close</Button>
                  </Modal.Footer>
                </Modal>


              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <ScrollToTop />
        {/* </div> */}

      </main >
    </>
  );
}
export default Cart;
const CartFlex = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: start;
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;
const CouponBtn = styled.div`
  border: 1px solid #ff8585;
  background-color: #ff8585;
  color: #fff;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 6px;
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 10px 0;
  svg {
    font-size: 18px;
  }
`;
const CardBoxContainer = styled.div`
  display: grid;
  row-gap: 16px;
  @media screen and (max-width: 1080px) {
    grid-template-columns: 1fr;
    column-gap: 0;
  }
`;
const CartBox = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid #988181;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
  display: grid;
  grid-template-columns: 2fr 0.8fr 0.8fr 0.8fr 0.5fr;
  align-items: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(16, 24, 40, 0.1);
    border-color: #e6ebf0;
  }

  @media screen and (max-width: 1080px) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;
const CartBoxTop = styled.div`
  display: grid;
  grid-template-columns: 2fr 0.8fr 0.8fr 0.8fr 0.5fr;
  padding: 6px 8px;
  margin: 10px 0 0 0;
  color: #667085;
  font-size: 13px;
  p {
    text-align: center;
    &:first-child { text-align: left; }
  }
  @media screen and (max-width: 1080px) { display: none; }
`;

const Section = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  &.one {
    justify-self: start;
    padding: 6px 12px;
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: 16px;
    align-items: center;
    img {
      border-radius: 10px;
    }
    @media screen and (max-width: 1080px) {
      grid-template-columns: 1fr;
      place-items: center;
      width: 100%;
    }
  }
  &.two {
    text-align: center;
    span {
      font-size: 22px;
      font-weight: 700;
      color: #101828;
    }
    @media screen and (max-width: 1080px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      justify-items: center;
      width: 100%;
      margin-bottom: 12px;
    }
  }
  &.three {
    @media screen and (max-width: 1080px) {
      display: none;
    }
  }
  &.four {
    h3 {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #101828;
    }
    span {
      font-size: 13px;
      color: #475467;
    }
  }
`;
const ImageContainer = styled.div`
  height: 160px;
  width: 160px;
  border-radius: 12px;
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #eef2f6;

  img {
    height: 100%;
    width: 100%;
    display: block;
    object-fit: cover;
  }
`;
const Link = styled.a`
  display: block;
  color: #111827;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.2;
  text-transform: capitalize;
  margin-bottom: 6px;
  &.smallLink {
    font-size: 13px;
    font-weight: 500;
    color: #475467;
    margin-bottom: 8px;
  }
`;
const QtyBtn = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 6px 10px;
  input {
    border: none;
    background: transparent;
    padding: 0 2px;
    display: inline-block;
    width: 36px;
    text-align: center;
    -moz-appearance: textfield; /* Firefox */
    -webkit-appearance: none; /* Safari/Chrome */
    appearance: none;
    font-size: 16px;
    font-weight: 700;
    color: #111827;
  }
  svg {
    font-size: 18px;
    color: #111827;
  }

  &.mobile {
    display: none;
    @media screen and (max-width: 1080px) {
      display: inline-flex;
    }
  }
`;
const Btn = styled.div`
  border: 1px solid #e5e7eb;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 999px;
  transition: background .15s ease, border-color .15s ease;
  &:hover { background: #f3f4f6; border-color: #d1d5db; }
`;
const SubTotalContainer = styled.div`
  display: grid;
  width: 100%;
  justify-items: end;
  margin: 30px 0;
`;
const SubTotal = styled.div`
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
  h3 {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 12px 0;
    color: #101828;
  }
  button { margin-top: 16px; }
  display: inline-block;
`;
const Text = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.2fr 1fr;
  padding: 6px 0;
  p { margin: 0; color: #111827; }
  &.total {
    p {
      font-size: 18px;
      font-weight: 700;
      color: #101828;
    }
  }
`;
const BackBtn = styled.div`
  margin: 0;
  background-color: #094c27;
  padding: 10px 25px;
  font-weight: 600;
  color: #fff;
  border-radius: 8px;
  font-size: 15px;
`;
const StyledCollapse = styled(Collapse)`
  input,
  select {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 12px;
    margin-bottom: 12px;
    font-family: "Montserrat";
    &::placeholder { font-family: "Montserrat"; }
  }
`;

// Added styled-components used by the cart layout
const Header = styled.div``;
const H2 = styled.h2``;
const LeftCol = styled.div``;
const RightCol = styled.div``;
const AddressBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #988181;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
  .label { color: #3a3a3a; font-weight: 500; margin-right: 10px; }
  .value { color: #111; font-weight: 600; }
`;
const ChangeButton = styled.button`
  border: 1px solid #187837;
  color: #187837;
  background: #fff;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  cursor: pointer;
  transition: all .2s ease;
  &:hover { background: #187837; color: #fff; }
`;
const SummaryCard = styled.div`
  background: #ffffff;
  border: 1px solid #988181;
  border-radius: 14px;
  padding: 16px;
  position: sticky;
  top: 20px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
`;
const SummaryTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
`;
const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  &.total { font-size: 16px; }
  span { font-size: 14px; color: #475467; }
`;
const DiscountValue = styled.span`
  color: #2ba24c;
`;
const Divider = styled.div`
  height: 1px;
  background: #988181;
  margin: 8px 0 12px 0;
`;
const OrderButton = styled.button`
  width: 100%;
  background: #ff8c1a;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background .2s ease, transform .1s ease;
  &:hover { background: #f38108; }
  &:active { transform: translateY(1px); }
`;

const AddressGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const AddressCard = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #e7eaee;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: border-color .15s ease, box-shadow .15s ease, transform .15s ease;
  &:hover { border-color: #d9dee4; box-shadow: 0 8px 20px rgba(16,24,40,.06); transform: translateY(-1px); }
  &.selected { border-color: #187837; box-shadow: 0 8px 22px rgba(24,120,55,.12); }
`;

const AddressName = styled.div`
  font-weight: 700;
  color: #101828;
  margin-bottom: 4px;
`;

const AddressMeta = styled.div`
  font-size: 13px;
  color: #475467;
  line-height: 1.4;
`;

const DeleteButton = styled.button`
  align-self: start;
  border: 1px solid #ef4444;
  color: #ef4444;
  background: #fff;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
  transition: all .15s ease;
  &:hover { background: #ef4444; color: #fff; }
`;

const SelectedPreview = styled.div`
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 10px 12px;
  margin: 8px 0 14px 0;
  color: #111827;
  font-size: 14px;
`;

const ModalForm = styled.div`
  .form__content label { font-size: 13px; font-weight: 600; color: #111827; }
  .form__content input, .form__content select {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 12px;
    background: #fff;
    color: #111827;
    width: 100%;
  }
  .form__content input:focus, .form__content select:focus {
    outline: none;
    border-color: #187837;
    box-shadow: 0 0 0 3px rgba(24,120,55,.12);
  }
`;
